import { render } from "./HomeReviews.vue?vue&type=template&id=34865605"
import script from "./HomeReviews.vue?vue&type=script&lang=js"
export * from "./HomeReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__